/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rte_Code_BlockInputs */



/**
* | output |
* | --- |
* | "Code block" |
*
* @param {Rte_Code_BlockInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const rte_code_block = /** @type {((inputs?: Rte_Code_BlockInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rte_Code_BlockInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Codeblok")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bloc de code")
	return /** @type {LocalizedString} */ ("Code block")
});